import React, { useEffect } from 'react'
import { defPath, fetchPath } from '../config/defPath'
import useLocalStorage from "../hooks/useLocalData"
import { useSession } from '../hooks/useState'
import Popups from "../components/layout/popup"
import { PopsController } from '../classes/popsController'
import { TLocalData } from '../../../@types/global'
import Alert from '../components/layout/Alert'

function App() {
    const { items, deleteItem } = useLocalStorage<TLocalData>()
    const [title, setTitle] = React.useState<string>('')
    const [description, setDescription] = React.useState<string>('')
    const [coins, setCoins] = React.useState<string>('')
    const [points, setPoints] = React.useState<string>('')
    const [continueButton, setContinueButton] = React.useState<{ url: string, text: string }>({ url: '', text: '' })

    const sendDatalayerThankyou = (e: React.MouseEvent) => {
        e.preventDefault()
        // @ts-ignore
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Continue Register',
            'interaction': 'true',
            'component_name': 'Thank_You_Page',
            'element_text': 'Continuar',
        });

        window.location.href = e.currentTarget.getAttribute('href') || ''

    }
    const handdleClose = () => {
        // @ts-ignore
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Close Thank You Page',
            'interaction': 'true',
            'component_name': 'Thank_You_Page',
            'element_text': 'Cerrar'
        });
        window.location.href = "/estadio-aguila"
    }

    const gettpyc = async () => {
        const storedItems = JSON.parse(sessionStorage.getItem('TUP'));

        setTitle(storedItems.typ1.title.value || '');
        setCoins(storedItems.coins || '');
        setPoints(storedItems.points || '');
        setDescription(storedItems.typ1.desc.value || '');
        setContinueButton(storedItems.typ1.btn || { text: '', url: '' });
    }

    React.useEffect(() => {
        gettpyc();
    }, [])

    React.useEffect(() => {
        if (Object.keys(items).length === 0) return
        if (window.drupalSettings && window.drupalSettings.user.uid.length) {
            if (items['predicciones']) {
                fetch(`${window.origin}/aguila/loyalty/send/predictions`, {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(items['predicciones'])
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data[0].message === "SUCCESS") {
                            setTimeout(() => {
                                items['predicciones'].length && items['predicciones'].forEach(((prediction: any) => {
                                    window.dataLayer.push({
                                        'event': 'GAEvent',
                                        'event_category': 'Content',
                                        'event_action': 'Button',
                                        'event_label': `${prediction.nameHome}_${prediction.nameAway} - ${prediction.league}`,
                                        'interaction': 'true',
                                        'component_name': 'Modo_Carrera_Predictions',
                                        'element_text': 'Guardar Marcadores',
                                    });
                                }))
                                window.openAlert({
                                    title: "Predicciones Guardadas",
                                    desc: "Haz clic aquí para editar",
                                    href: '/estadio-aguila/predicciones'
                                })
                                if (data[0].popup) {
                                    setTimeout(() => {
                                        window.openAlert({
                                            title: `${data[0].popup}`,
                                            time: 6000
                                        })
                                    }, 6000)
                                }
                            }, 1000);
                        }
                    }).finally(() => {
                        deleteItem("predicciones")
                    })
            }
            if (items['tada']) {
                setTimeout(() => {

                    const { tada_code } = items['tada'] as { tada_code: string }
                    fetch(`${window.origin}/aguila/loyalty/tadacode`, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ tada_code })
                    })
                        .then(res => res.json())
                        .then(data => {

                            if (data.total) {
                                useSession.setState({ coins: parseInt(data.total.coins) })
                                useSession.setState({ points: parseInt(data.total.points) })
                            }

                            if (data.redirect) {
                                window.location.href = data.redirect
                                return
                            }

                            new PopsController().open('tada', data)

                            if (data.popup) {
                                setTimeout(() => {
                                    window.openAlert({
                                        title: `${data.popup}`,
                                        time: 6000
                                    })
                                }, 6000)
                            }

                        }).finally(() => {
                            deleteItem("tada")
                        })
                }, 1000);

            }
        }

    }, [items])

    return (
        <>
            <Alert />
            <div className="pageRegister ar__content pageThanks" id="content-login">
                <a className="close__modal" onClick={handdleClose}></a>
                <div className="ar__thank ar__content__section" id="thankyouPage">
                    <div className="logo logo-olas">
                        <img src={`${defPath}/assets/images/newHeaderTopLogos/olas.png`} alt="Logo Olas" />
                    </div>
                    <a href="/estadio-aguila" className="logo logo-modal">
                        <img src={`${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Aguila" />
                    </a>
                    <div className="ar__content__title">
                        <h1 className="ar__thank__title title_2 whiteShadow" dangerouslySetInnerHTML={{ __html: title }}></h1>
                    </div>

                    {points &&
                        <>
                            <p className="ar__thank__subtitle">Te regalamos</p>
                            <div className="ar__thank__gifts">
                                <div className="ar__thank__gifts-text whiteShadow">
                                    <span>+{points}</span> pts
                                </div>
                                <div className="ar__thank__gifts-text whiteShadow">
                                    <span>+{coins}</span>
                                    <img src={`${defPath}/assets/images/icons/coins.png`} alt="icono monedas" />
                                </div>
                            </div>
                        </>}

                    <div className="ar__thank__text medium_30" dangerouslySetInnerHTML={{ __html: description }}></div>

                    {continueButton.text ? <a href={continueButton.url} className="ar__btn-primary ar__btn" onClick={sendDatalayerThankyou}>{continueButton.text}</a> : ''}

                </div>
            </div>
            <Popups />

        </>
    )
}

export default App
